import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import maverickPortalhttp from '../../utils/webService/webService';
import maverickPortalApiEndPoint from '../../config/apiEndPoint';

import ProjectWrapper from './ProjectWrapper';
import { Text } from '../../common';
import { NavTab, NavTabs, NavTabsContainer } from '../../common/NewTab';
import DesignFormTab from '../Design/DesignFormTab';
import DesignInterviewTab from '../Design/DesignInterviewTab';
// import Tooltip from '../../common/Tooltip';
// import PageLoader from '../PageLoader';

const Container = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--deepBlue);
`;

export default function DesignScreen() {
  const loggedUser = useSelector(state => state.LoginReducer);
  const { projectId } = useParams();
  const initKeyRef = useRef(null);

  const [projectTitle, setProjectTitle] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [taskList, setTaskList] = useState([]);
  const [questionTypeList, setQuestionTypeList] = useState([]);
  const [screenerTypeOption, setScreenerTypeOption] = useState([]);
  const [masterTags, setMasterTags] = useState([]);
  const [videoTaskList, setVideoTaskList] = useState([]);
  const [projectStatus, setprojectStatus] = useState([]);
  const [ValueTypeChoices, setValueTypeChoices] = useState([]);
  const [addQuestionDisable, setAddQuestionDisable] = useState(false);
  // const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [step, setStep] = useState(1);
  const [isTaskDescriptionEditing, setIsTaskDescriptionEditing] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);

  const taskStatus = useSelector(state => state.TaskReducer?.editQuestion);
  const taskStatusCode = taskStatus?.StatusCode;

  const dispatch = useDispatch();

  // Re-usable: fetch resume and initialize tasks/status
  const fetchResumeAndInit = () => {
    if (!loggedUser?.userId || !projectId) return;

    // setIsLoading(true); // start loader
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.Resume.url + '/' + loggedUser.userId + '/' + projectId,
        maverickPortalApiEndPoint.Resume.methodType
      )
      .then(response => {
        let projectData = response.data.Response;
        setTasks(projectData?.projectTask_data);
        if (projectData?.project_data?.length > 0) {
          setProjectTitle(projectData?.project_data[0]?.identity);
          getTaskQuestion(
            projectData?.projectTask_data[0]?.taskType,
            projectData?.projectTask_data[0]?.projectTask_ID,
            projectData?.projectTask_data[0]?.IsVisited
          );
        }
        setprojectStatus(
          projectData?.projectStatus != undefined
            ? projectData?.projectStatus[0]?.steps_array != undefined
              ? projectData.projectStatus[0]?.steps_array
              : ''
            : ''
        );
        // .finally(() => setIsLoading(false));
      });
  };

  // Handle task description editing
  const handleTaskDescriptionEdit = (task, newDescription) => {
    setCurrentTask({ ...task, taskDescription: newDescription });
    setIsTaskDescriptionEditing(true);
  };

  // Handle save task description
  const handleSaveTaskDescription = () => {
    if (currentTask) {
      const payload = {
        user_ID: loggedUser.userId,
        projectsTask_ID: currentTask.projectTask_ID,
        taskName: currentTask.taskName,
        taskDescription: currentTask.taskDescription,
        taskDuration: currentTask.taskDuration,
        taskType: currentTask.taskType === 'Video' ? 2 : 1,
        IsEditable: currentTask.IsEditable
      };
      dispatch({ type: 'EDIT_PROJECT_TASK', payload });
      setIsTaskDescriptionEditing(false);

      // Refresh lists and task/question data after save
      fetchResumeAndInit();
    }
  };

  useEffect(() => {
    // PersistGate renders before rehydrate (loading={null}), so userId is null on
    // the first pass and then becomes real — guard to avoid a second fetch.
    if (!loggedUser?.userId || !projectId) return;

    const initKey = `${projectId}:${loggedUser.userId}`;
    if (initKeyRef.current === initKey) return;
    initKeyRef.current = initKey;

    fetchResumeAndInit();
  }, [projectId, loggedUser.userId]);

  // useEffect(() => {
  //   maverickPortalhttp
  //     .makeRequest(
  //       maverickPortalApiEndPoint.Resume.url + '/' + loggedUser.userId + '/' + projectId,
  //       maverickPortalApiEndPoint.Resume.methodType
  //     )
  //     .then(response => {
  //       let projectData = response.data.Response;

  //       let ptasktype = projectData?.projectTask_data[1]?.taskType;
  //       let ptaskid = projectData?.projectTask_data[1]?.projectTask_ID;
  //       let pisvisited = projectData?.projectTask_data[1]?.IsVisited;
  //       if (projectData?.projectTask_data?.length > 1 && ptasktype == 'Video') {
  //         // getTaskQuestion(projectData?.projectTask_data[1]?.taskType, projectData?.projectTask_data[1]?.projectTask_ID, projectData?.projectTask_data[1]?.IsVisited);
  //         maverickPortalhttp
  //           .makeRequest(
  //             `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${ptaskid}`,
  //             maverickPortalApiEndPoint.getVideoTask.methodType
  //           )
  //           .then(response => {
  //             let videoTaskData = response.data.Response;
  //             setMasterTags(videoTaskData?.masterTag);
  //           });
  //       }
  //     });

  //   setTimeout(() => {
  //     dispatch({ type: 'CLEAR_EDIT_QUESTION' });
  //   }, 800);
  // }, [taskStatusCode]);

  const getTaskQuestion = (taskType, taskId, isVisited) => {
    // setIsLoading(true); // start loader on tab change
    
    // Find and set the current task
    const task = tasks.find(t => t.projectTask_ID === taskId);
    if (task) {
      setCurrentTask(task);
    }
    
    if (taskType == 'Form') {
      maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getProjectTask.url}/${loggedUser.userId}/${projectId}/${taskId}`,
          maverickPortalApiEndPoint.getProjectTask.methodType
        )
        .then(response => {
          let taskData = response.data.Response;
          setTaskList(taskData?.GetProjectTaskQuestions);
          setQuestionTypeList(taskData?.questionType);
          setValueTypeChoices(taskData?.ValueTypeChoices);
        });
        // .finally(() => setIsLoading(false));
    } else if (taskType == 'Video') {
      maverickPortalhttp
        .makeRequest(
          `${maverickPortalApiEndPoint.getVideoTask.url}/${loggedUser.userId}/${projectId}/${taskId}`,
          maverickPortalApiEndPoint.getVideoTask.methodType
        )
        .then(response => {
          let videoTaskData = response.data.Response;
          setVideoTaskList(videoTaskData?.GetProjectTaskQuestions);
          setQuestionTypeList(videoTaskData?.questionType);
          setScreenerTypeOption(videoTaskData?.dropDownForScreenerTypeQ);
          setMasterTags(videoTaskData?.masterTag);
          setValueTypeChoices(videoTaskData?.ValueTypeChoices);
        });
    }

    if (isVisited == 0) {
      const data = {
        user_ID: loggedUser.userId,
        projectTask_ID: taskId
      };
      dispatch({ type: 'REQUEST_UPDATE_TASK_STATUS', payload: data });
    }
  };

  // if (isLoading) {
  //   return (
  //     <div className="flex justify-center items-center py-20">
  //       <PageLoader size="100px" />
  //     </div>
  //   );
  // }

  return (
    <ProjectWrapper projectTitle={projectTitle} step={3} projectStatus={projectStatus} projectId={projectId}>
      <Text type="3">Select a task and start editing the template to better suit your projects needs</Text>
      <Container className="mt-3">
        <NavTabsContainer className="px-3 ">
          <NavTabs>
            {tasks?.map((task, taskIndex) => {
              return (
                <NavTab
                  key={taskIndex}
                  active={step === taskIndex + 1}
                  onClick={() => {
                    setStep(taskIndex + 1);
                    getTaskQuestion(task.taskType, task.projectTask_ID, task.IsVisited);
                  }}
                  fontSize="12px"
                >
                  {task.taskName}
                  {/* {task.taskType != 'Video' ? task.taskType : 'Interview'} */}
                </NavTab>
              );
            })}
            {/* <Tooltip
              left="-10px"
              top="-30px"
              direction="bottom"
              number="1/3"
              information="Select the task to view and edit the template"
            ></Tooltip> */}
          </NavTabs>
        </NavTabsContainer>
      </Container>
      <div className="mt-3">
        {tasks?.map((task, taskIndex) => {
          const isActive = taskIndex + 1 === step;

          if (!isActive) {
            return null;
          }

          if (task?.taskType === 'Form') {
            return (
              <div key={taskIndex}>
                <DesignFormTab
                  task={task}
                  nextTask={tasks.length === taskIndex + 1 ? tasks[0] : tasks[taskIndex + 1]}
                  taskList={taskList}
                  questionTypeList={questionTypeList}
                  ValueTypeChoices={ValueTypeChoices}
                  addQuestionDisable={addQuestionDisable}
                  setAddQuestionDisable={setAddQuestionDisable}
                  isTaskDescriptionEditing={isTaskDescriptionEditing}
                  onTaskDescriptionEdit={handleTaskDescriptionEdit}
                  onSaveTaskDescription={handleSaveTaskDescription}
                  handleTaskTab={(taskType, projectTask_ID, IsVisited) => {
                    const idx = tasks.findIndex(t => t.projectTask_ID === projectTask_ID);
                    setStep(idx !== -1 ? idx + 1 : step);
                    getTaskQuestion(taskType, projectTask_ID, IsVisited);
                  }}
                />
              </div>
            );
          }

          if (task.taskType === 'Video') {
            return (
              <div key={taskIndex}>
                <DesignInterviewTab
                  task={task}
                  nextTask={tasks.length === taskIndex + 1 ? tasks[0] : tasks[taskIndex + 1]}
                  videoTaskList={videoTaskList}
                  questionTypeList={questionTypeList}
                  screenerTypeOption={screenerTypeOption}
                  ValueTypeChoices={ValueTypeChoices}
                  masterTags={masterTags}
                  addQuestionDisable={addQuestionDisable}
                  setAddQuestionDisable={setAddQuestionDisable}
                  isTaskDescriptionEditing={isTaskDescriptionEditing}
                  onTaskDescriptionEdit={handleTaskDescriptionEdit}
                  onSaveTaskDescription={handleSaveTaskDescription}
                  handleTaskTab={(taskType, projectTask_ID, IsVisited) => {
                    const idx = tasks.findIndex(t => t.projectTask_ID === projectTask_ID);
                    setStep(idx !== -1 ? idx + 1 : step);
                    getTaskQuestion(taskType, projectTask_ID, IsVisited);
                  }}
                />
              </div>
            );
          }

          return null;
        })}
      </div>
    </ProjectWrapper>
  );
}
